// extracted by mini-css-extract-plugin
export default {"iconsContainer":"ot5Xd4Uz","desktop":"desktop","mobile":"mobile","icon":"zDfn4qGw"};